<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Info', route: '/backoffice/info/' }, { label: 'Modifica Info', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Modifica info</h1>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formInfo" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati info</h2>
            <span class="ac-meta">titolo e descrizione per ogni voce</span>
        </div>

        <div class="flex lg:flex-row flex-col gap-6">
            <div *ngFor="let contenuto of info?.items" class="flex flex-col gap-4 flex-1">
                <div class="fld">
                    <label>* Titolo</label>
                    <input type="text" pInputText class="w-full" placeholder="Titolo" [formControlName]="'titolo_' + contenuto.id" />
                    <small class="text-red-600 block mt-2 font-medium" *ngIf="formInfo.get('titolo_' + contenuto.id)?.hasError('required') && (formInfo.get('titolo_' + contenuto.id)?.dirty || formInfo.get('titolo_' + contenuto.id)?.touched)">Il titolo è obbligatorio.</small>
                </div>
                <div class="fld">
                    <label>Descrizione</label>
                    <p-editor [style]="{ height: '150px' }" [formControlName]="'descrizione_' + contenuto.id" />
                </div>
                <div class="flex justify-end" *ngIf="info?.items!.length !== 1">
                    <button class="acc-btn acc-btn-ghost" type="button" (click)="onRemoveItem(contenuto.id)">Rimuovi dato</button>
                </div>
            </div>
        </div>

        <div class="acc-actions">
            <button class="acc-btn" type="button" (click)="onAddItem()">Aggiungi un dato</button>
            <p-confirmPopup #confirmPopupRef>
                <ng-template pTemplate="headless" let-message>
                    <div class="border-round p-3">
                        <span class="text-base">{{ message.message }}</span>
                        <div class="flex align-items-center gap-2 mt-3">
                            <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>
                            <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnulla()">Annulla</button>
                        </div>
                    </div>
                </ng-template>
            </p-confirmPopup>
            <button class="acc-btn" type="button" (click)="onDeletePopup($event)">Elimina la info</button>
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/info">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formInfo.valid">Salva modifiche</button>
        </div>
    </form>
</section>
